import {getOnError} from '@frontrow/console/src/entities/helpers/exception-handlers/bugsnag-helper/bugsnag-onerror'
import consoleBugsnagClient from '@frontrow/console/src/helpers/exception-handlers/bugsnag-client'

export function initializeGlobalEventListeners() {
  // as far as I can tell, the getOnError function actually always returns `noop`, so this is doing nothing
  window.onerror = getOnError(consoleBugsnagClient)
}
